var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"schedule-info-attendance"},[_c('p',[_vm._v("点击确认，老师将收到短信通知")]),_c('button',{on:{"click":_vm.setAttdendance}},[_vm._v("确认"+_vm._s(_vm.type === 4 ? "请假" : "取消请假"))])])}
var staticRenderFns = []

export { render, staticRenderFns }